/**
 * @desc SKU-导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.productSku.exportExcel.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productSku/exportExcel`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
